import PropTypes from 'prop-types'
import { useState } from 'react'
import { ListGroup, ListGroupItem, CustomInput, Collapse } from 'reactstrap'

const propTypes = {
  formik     : PropTypes.object,
  fieldName  : PropTypes.string,
  conditions : PropTypes.arrayOf(PropTypes.object)
}

const defaultProps = {
  formik     : {},
  fieldName  : '',
  conditions : [ {} ]
}

/**
 * @param {string} name - name of the field in formik
 * @param {[string]} conditions - options for conditions
 */
const ProductConditionFilterField = ({
  formik,
  fieldName,
  conditions
}) => {

  const [ collapse, setCollapse ] = useState(true)

  const handleChange = (event, condition) => {
    const { checked } = event.target
    const conditionId = condition.id
    if (checked) {
      // manually push to formik values
      const newSelectedConditionIds = [ ...formik.values[ fieldName ], conditionId ]
      formik.setFieldValue(fieldName, newSelectedConditionIds)
    } else {
      const newSelectedConditionIds = formik.values[fieldName].filter((formikCondId) => formikCondId !== conditionId)
      formik.setFieldValue(fieldName, newSelectedConditionIds)
    }
  }
  return (
    <>
      <div className='filter-title font-weight-bold pb-2'
        onClick={ () => setCollapse(!collapse) }
      >
        { 'CONDITIONS' }
        <i className={ `float-right fas fa-chevron-${ collapse ? 'up' : 'down' }` } />
      </div>

      <Collapse isOpen={ collapse }>
        <ListGroup flush>
          {
            conditions.map((condition) => (
              <ListGroupItem
                key={ `conditions-filter-options-${condition.id}` }
                name='condition_ids'
              >
                <CustomInput
                  id={ condition.label }
                  name={ condition.label }
                  type='checkbox'
                  checked={ formik.values[fieldName].includes(condition.id) }
                  onChange={ (event) => handleChange(event, condition) }
                  className='float-left'
                  label={ condition.label }
                />
              </ListGroupItem>
            ))
          }
        </ListGroup>
      </Collapse>
    </>
  )
}

ProductConditionFilterField.propTypes    = propTypes
ProductConditionFilterField.defaultProps = defaultProps

export default ProductConditionFilterField
